import { Button } from "@devhop/ui";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import {
  useCloseShiftMutation,
  useOpenShift,
  useOpenShiftMutation,
} from "../api/queries";
import { usePOSContext } from "../context/POSContext";
import { CloseShiftDialog } from "./CloseShiftDialog";
import { OpenShiftDialog } from "./OpenShiftDialog";

export function ShiftStatusIndicator() {
  const { selection } = usePOSContext();
  const branchId = selection?.branchId ?? null;
  const deviceId = selection?.deviceId ?? null;

  const [isOpenDialogOpen, setIsOpenDialogOpen] = useState(false);
  const [isCloseDialogOpen, setIsCloseDialogOpen] = useState(false);

  const { data: openShift, isLoading } = useOpenShift(branchId, deviceId);
  const openShiftMutation = useOpenShiftMutation();
  const closeShiftMutation = useCloseShiftMutation();

  if (!branchId || !deviceId) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm">ກຳລັງໂຫຼດ...</span>
      </div>
    );
  }

  if (openShift) {
    const openingFloat = Number(openShift.openingFloat);

    return (
      <>
        <div className="flex items-center gap-3">
          {/* <Badge
            variant="outline"
            className="border-green-200 bg-green-50 text-green-700"
          >
            <Clock className="mr-1 h-3 w-3" />
            Shift: ເປີດ
          </Badge> */}
          <div className="text-muted-foreground text-xs">
            <div>ເງິນຕົ້ນ: {openingFloat.toLocaleString("lo-LA")} ₭</div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsCloseDialogOpen(true)}
            disabled={closeShiftMutation.isPending}
          >
            {closeShiftMutation.isPending ? (
              <>
                <Loader2 className="mr-2 h-3 w-3 animate-spin" />
                ກຳລັງປິດ...
              </>
            ) : (
              "ປິດກະ"
            )}
          </Button>
        </div>

        <CloseShiftDialog
          open={isCloseDialogOpen}
          onOpenChange={setIsCloseDialogOpen}
          shiftId={openShift.id}
          branchId={branchId}
          deviceId={deviceId}
          onSuccess={() => {
            setIsCloseDialogOpen(false);
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className="flex items-center gap-2">
        {/* <Badge
          variant="outline"
          className="border-gray-200 bg-gray-50 text-gray-700"
        >
          <Clock className="mr-1 h-3 w-3" />
          Shift: ປິດ
        </Badge> */}
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsOpenDialogOpen(true)}
          disabled={openShiftMutation.isPending}
        >
          {openShiftMutation.isPending ? (
            <>
              <Loader2 className="mr-2 h-3 w-3 animate-spin" />
              ກຳລັງເປີດ...
            </>
          ) : (
            "ເປີດກະ"
          )}
        </Button>
      </div>

      <OpenShiftDialog
        open={isOpenDialogOpen}
        onOpenChange={setIsOpenDialogOpen}
        branchId={branchId}
        deviceId={deviceId}
        onSuccess={() => {
          setIsOpenDialogOpen(false);
        }}
      />
    </>
  );
}
